import { Nationality } from '@prisma/client'
import { buildKeys } from '~/utils/keys/keyBuilder'

export const nationalityKeys = buildKeys({
  [Nationality.FRA]: 'Française (France)',
  [Nationality.AFG]: 'Afghane (Afghanistan)',
  [Nationality.ALB]: 'Albanaise (Albanie)',
  [Nationality.DZA]: 'Algérienne (Algérie)',
  [Nationality.DEU]: 'Allemande (Allemagne)',
  [Nationality.USA]: 'Américaine (États-Unis)',
  [Nationality.AND]: 'Andorrane (Andorre)',
  [Nationality.AGO]: 'Angolaise (Angola)',
  [Nationality.ATG]: 'Antiguaise-et-Barbudienne (Antigua-et-Barbuda)',
  [Nationality.ARG]: 'Argentine (Argentine)',
  [Nationality.ARM]: 'Arménienne (Arménie)',
  [Nationality.AUS]: 'Australienne (Australie)',
  [Nationality.AUT]: 'Autrichienne (Autriche)',
  [Nationality.AZE]: 'Azerbaïdjanaise (Azerbaïdjan)',
  [Nationality.BHS]: 'Bahamienne (Bahamas)',
  [Nationality.BHR]: 'Bahreïnienne (Bahreïn)',
  [Nationality.BGD]: 'Bangladaise (Bangladesh)',
  [Nationality.BRB]: 'Barbadienne (Barbade)',
  [Nationality.BEL]: 'Belge (Belgique)',
  [Nationality.BLZ]: 'Bélizienne (Belize)',
  [Nationality.BEN]: 'Béninoise (Bénin)',
  [Nationality.BTN]: 'Bhoutanaise (Bhoutan)',
  [Nationality.BLR]: 'Biélorusse (Biélorussie)',
  [Nationality.MMR]: 'Birmane (Birmanie)',
  [Nationality.GNB]: 'Bissau-Guinéenne (Guinée-Bissau)',
  [Nationality.BOL]: 'Bolivienne (Bolivie)',
  [Nationality.BIH]: 'Bosnienne (Bosnie-Herzégovine)',
  [Nationality.BWA]: 'Botswanaise (Botswana)',
  [Nationality.BRA]: 'Brésilienne (Brésil)',
  [Nationality.GBR]: 'Britannique (Royaume-Uni)',
  [Nationality.BRN]: 'Brunéienne (Brunei)',
  [Nationality.BGR]: 'Bulgare (Bulgarie)',
  [Nationality.BFA]: 'Burkinabée (Burkina)',
  [Nationality.BDI]: 'Burundaise (Burundi)',
  [Nationality.KHM]: 'Cambodgienne (Cambodge)',
  [Nationality.CMR]: 'Camerounaise (Cameroun)',
  [Nationality.CAN]: 'Canadienne (Canada)',
  [Nationality.CPV]: 'Cap-verdienne (Cap-Vert)',
  [Nationality.CAF]: 'Centrafricaine (Centrafrique)',
  [Nationality.CHL]: 'Chilienne (Chili)',
  [Nationality.CHN]: 'Chinoise (Chine)',
  [Nationality.CYP]: 'Chypriote (Chypre)',
  [Nationality.COL]: 'Colombienne (Colombie)',
  [Nationality.COM]: 'Comorienne (Comores)',
  [Nationality.COG]: 'Congolaise (Congo-Brazzaville)',
  [Nationality.COD]: 'Congolaise (Congo-Kinshasa)',
  [Nationality.COK]: 'Cookienne (Îles Cook)',
  [Nationality.CRI]: 'Costaricaine (Costa Rica)',
  [Nationality.HRV]: 'Croate (Croatie)',
  [Nationality.CUB]: 'Cubaine (Cuba)',
  [Nationality.DNK]: 'Danoise (Danemark)',
  [Nationality.DJI]: 'Djiboutienne (Djibouti)',
  [Nationality.DOM]: 'Dominicaine (République dominicaine)',
  [Nationality.DMA]: 'Dominiquaise (Dominique)',
  [Nationality.EGY]: 'Égyptienne (Égypte)',
  [Nationality.ARE]: 'Émirienne (Émirats arabes unis)',
  [Nationality.GNQ]: 'Équato-guinéenne (Guinée équatoriale)',
  [Nationality.ECU]: 'Équatorienne (Équateur)',
  [Nationality.ERI]: 'Érythréenne (Érythrée)',
  [Nationality.ESP]: 'Espagnole (Espagne)',
  [Nationality.TLS]: 'Est-timoraise (Timor-Leste)',
  [Nationality.EST]: 'Estonienne (Estonie)',
  [Nationality.ETH]: 'Éthiopienne (Éthiopie)',
  [Nationality.FJI]: 'Fidjienne (Fidji)',
  [Nationality.FIN]: 'Finlandaise (Finlande)',
  [Nationality.GAB]: 'Gabonaise (Gabon)',
  [Nationality.GMB]: 'Gambienne (Gambie)',
  [Nationality.GEO]: 'Géorgienne (Géorgie)',
  [Nationality.GHA]: 'Ghanéenne (Ghana)',
  [Nationality.GRD]: 'Grenadienne (Grenade)',
  [Nationality.GTM]: 'Guatémaltèque (Guatemala)',
  [Nationality.GIN]: 'Guinéenne (Guinée)',
  [Nationality.GUY]: 'Guyanienne (Guyana)',
  [Nationality.HTI]: 'Haïtienne (Haïti)',
  [Nationality.GRC]: 'Hellénique (Grèce)',
  [Nationality.HND]: 'Hondurienne (Honduras)',
  [Nationality.HUN]: 'Hongroise (Hongrie)',
  [Nationality.IND]: 'Indienne (Inde)',
  [Nationality.IDN]: 'Indonésienne (Indonésie)',
  [Nationality.IRQ]: 'Irakienne (Iraq)',
  [Nationality.IRN]: 'Iranienne (Iran)',
  [Nationality.IRL]: 'Irlandaise (Irlande)',
  [Nationality.ISL]: 'Islandaise (Islande)',
  [Nationality.ISR]: 'Israélienne (Israël)',
  [Nationality.ITA]: 'Italienne (Italie)',
  [Nationality.CIV]: "Ivoirienne (Côte d'Ivoire)",
  [Nationality.JAM]: 'Jamaïcaine (Jamaïque)',
  [Nationality.JPN]: 'Japonaise (Japon)',
  [Nationality.JOR]: 'Jordanienne (Jordanie)',
  [Nationality.KAZ]: 'Kazakhstanaise (Kazakhstan)',
  [Nationality.KEN]: 'Kényane (Kenya)',
  [Nationality.KGZ]: 'Kirghize (Kirghizistan)',
  [Nationality.KIR]: 'Kiribatienne (Kiribati)',
  [Nationality.KNA]: 'Kittitienne et Névicienne (Saint-Christophe-et-Niévès)',
  [Nationality.XKO]: 'Kosovare (Kosovo)',
  [Nationality.KWT]: 'Koweïtienne (Koweït)',
  [Nationality.LAO]: 'Laotienne (Laos)',
  [Nationality.LSO]: 'Lesothane (Lesotho)',
  [Nationality.LVA]: 'Lettone (Lettonie)',
  [Nationality.LBN]: 'Libanaise (Liban)',
  [Nationality.LBR]: 'Libérienne (Liberia)',
  [Nationality.LBY]: 'Libyenne (Libye)',
  [Nationality.LIE]: 'Liechtensteinoise (Liechtenstein)',
  [Nationality.LTU]: 'Lituanienne (Lituanie)',
  [Nationality.LUX]: 'Luxembourgeoise (Luxembourg)',
  [Nationality.MKD]: 'Macédonienne (Macédoine)',
  [Nationality.MYS]: 'Malaisienne (Malaisie)',
  [Nationality.MWI]: 'Malawienne (Malawi)',
  [Nationality.MDV]: 'Maldivienne (Maldives)',
  [Nationality.MDG]: 'Malgache (Madagascar)',
  [Nationality.MLI]: 'Malienne (Mali)',
  [Nationality.MLT]: 'Maltaise (Malte)',
  [Nationality.MAR]: 'Marocaine (Maroc)',
  [Nationality.MHL]: 'Marshallaise (Îles Marshall)',
  [Nationality.MUS]: 'Mauricienne (Maurice)',
  [Nationality.MRT]: 'Mauritanienne (Mauritanie)',
  [Nationality.MEX]: 'Mexicaine (Mexique)',
  [Nationality.FSM]: 'Micronésienne (Micronésie)',
  [Nationality.MDA]: 'Moldave (Moldavie)',
  [Nationality.MCO]: 'Monegasque (Monaco)',
  [Nationality.MNG]: 'Mongole (Mongolie)',
  [Nationality.MNE]: 'Monténégrine (Monténégro)',
  [Nationality.MOZ]: 'Mozambicaine (Mozambique)',
  [Nationality.NAM]: 'Namibienne (Namibie)',
  [Nationality.NRU]: 'Nauruane (Nauru)',
  [Nationality.NLD]: 'Néerlandaise (Pays-Bas)',
  [Nationality.NZL]: 'Néo-Zélandaise (Nouvelle-Zélande)',
  [Nationality.NPL]: 'Népalaise (Népal)',
  [Nationality.NIC]: 'Nicaraguayenne (Nicaragua)',
  [Nationality.NGA]: 'Nigériane (Nigeria)',
  [Nationality.NER]: 'Nigérienne (Niger)',
  [Nationality.NIU]: 'Niuéenne (Niue)',
  [Nationality.PRK]: 'Nord-coréenne (Corée du Nord)',
  [Nationality.NOR]: 'Norvégienne (Norvège)',
  [Nationality.OMN]: 'Omanaise (Oman)',
  [Nationality.UGA]: 'Ougandaise (Ouganda)',
  [Nationality.UZB]: 'Ouzbèke (Ouzbékistan)',
  [Nationality.PAK]: 'Pakistanaise (Pakistan)',
  [Nationality.PLW]: 'Palaosienne (Palaos)',
  [Nationality.PSE]: 'Palestinienne (Palestine)',
  [Nationality.PAN]: 'Panaméenne (Panama)',
  [Nationality.PNG]: 'Papouane-Néo-Guinéenne (Papouasie-Nouvelle-Guinée)',
  [Nationality.PRY]: 'Paraguayenne (Paraguay)',
  [Nationality.PER]: 'Péruvienne (Pérou)',
  [Nationality.PHL]: 'Philippine (Philippines)',
  [Nationality.POL]: 'Polonaise (Pologne)',
  [Nationality.PRT]: 'Portugaise (Portugal)',
  [Nationality.QAT]: 'Qatarienne (Qatar)',
  [Nationality.ROU]: 'Roumaine (Roumanie)',
  [Nationality.RUS]: 'Russe (Russie)',
  [Nationality.RWA]: 'Rwandaise (Rwanda)',
  [Nationality.LCA]: 'Saint-Lucienne (Sainte-Lucie)',
  [Nationality.SMR]: 'Saint-Marinaise (Saint-Marin)',
  [Nationality.VCT]:
    'Saint-Vincentaise et Grenadine (Saint-Vincent-et-les Grenadines)',
  [Nationality.SLB]: 'Salomonaise (Îles Salomon)',
  [Nationality.SLV]: 'Salvadorienne (Salvador)',
  [Nationality.WSM]: 'Samoane (Samoa)',
  [Nationality.STP]: 'Santoméenne (Sao Tomé-et-Principe)',
  [Nationality.SAU]: 'Saoudienne (Arabie saoudite)',
  [Nationality.SEN]: 'Sénégalaise (Sénégal)',
  [Nationality.SRB]: 'Serbe (Serbie)',
  [Nationality.SYC]: 'Seychelloise (Seychelles)',
  [Nationality.SLE]: 'Sierra-Léonaise (Sierra Leone)',
  [Nationality.SGP]: 'Singapourienne (Singapour)',
  [Nationality.SVK]: 'Slovaque (Slovaquie)',
  [Nationality.SVN]: 'Slovène (Slovénie)',
  [Nationality.SOM]: 'Somalienne (Somalie)',
  [Nationality.SDN]: 'Soudanaise (Soudan)',
  [Nationality.LKA]: 'Sri-Lankaise (Sri Lanka)',
  [Nationality.ZAF]: 'Sud-Africaine (Afrique du Sud)',
  [Nationality.KOR]: 'Sud-Coréenne (Corée du Sud)',
  [Nationality.SSD]: 'Sud-Soudanaise (Soudan du Sud)',
  [Nationality.SWE]: 'Suédoise (Suède)',
  [Nationality.CHE]: 'Suisse (Suisse)',
  [Nationality.SUR]: 'Surinamaise (Suriname)',
  [Nationality.SWZ]: 'Swazie (Swaziland)',
  [Nationality.SYR]: 'Syrienne (Syrie)',
  [Nationality.TJK]: 'Tadjike (Tadjikistan)',
  [Nationality.TZA]: 'Tanzanienne (Tanzanie)',
  [Nationality.TCD]: 'Tchadienne (Tchad)',
  [Nationality.CZE]: 'Tchèque (Tchéquie)',
  [Nationality.THA]: 'Thaïlandaise (Thaïlande)',
  [Nationality.TGO]: 'Togolaise (Togo)',
  [Nationality.TON]: 'Tonguienne (Tonga)',
  [Nationality.TTO]: 'Trinidadienne (Trinité-et-Tobago)',
  [Nationality.TUN]: 'Tunisienne (Tunisie)',
  [Nationality.TKM]: 'Turkmène (Turkménistan)',
  [Nationality.TUR]: 'Turque (Turquie)',
  [Nationality.TUV]: 'Tuvaluane (Tuvalu)',
  [Nationality.UKR]: 'Ukrainienne (Ukraine)',
  [Nationality.URY]: 'Uruguayenne (Uruguay)',
  [Nationality.VUT]: 'Vanuatuane (Vanuatu)',
  [Nationality.VAT]: 'Vaticane (Vatican)',
  [Nationality.VEN]: 'Vénézuélienne (Venezuela)',
  [Nationality.VNM]: 'Vietnamienne (Viêt Nam)',
  [Nationality.YEM]: 'Yéménite (Yémen)',
  [Nationality.ZMB]: 'Zambienne (Zambie)',
  [Nationality.ZWE]: 'Zimbabwéenne (Zimbabwe)'
})
